import { get } from "../base.schmaltz.model";
import { deserialize } from "../base.serializer";

export const getSiteFeatures = async (params: any) => {
  const path = "site-features";

  try {
    const res = await get(path, params);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
